import {RequestEntity} from "../types/RequestEntity";
import {CombinedEquipmentRequestEntity} from "../../../../graphql/graphQlApiHooks";

export const isCombinedRequest = (entity: RequestEntity): entity is CombinedEquipmentRequestEntity => entity?.__typename === 'CombinedEquipmentRequestEntity';
